import ProtectedLayout from './ProtectedLayout'
import PublicLayout from './PublicLayout'

export default { ProtectedLayout, PublicLayout }
